import React from 'react';
import { Control, Errors } from 'react-redux-form';
import CustomSearchableDropdown from './custom-searchable-dropdown.component';

const CustomSearch = (props) => <CustomSearchableDropdown {...props} />;
  
  const CustomSearchableDropdownWrapper = ({ fieldProp, ...restProps }) => {  
  const ErrorMessageComponent = (props) => {
      return <div>{props.children}</div>;
  };
  const ErrorBorderWrapper = (props) => {
      const isWarning = Object.keys(props.fieldValue.errors).some(r => r.includes("warning_"));
      return <div className={isWarning ? "" : "has-error"}></div>
  };
  return (
      <>
          <Errors model={fieldProp} wrapper={ErrorBorderWrapper} />
          <Control.text
              model={fieldProp}
              className="control-field"
              component={CustomSearch}
              fieldProp={fieldProp}
              {...restProps}
          />
          <Errors model={fieldProp} className="control-errors" component={ErrorMessageComponent} />
      </>
  );
};

export default CustomSearchableDropdownWrapper;
